export default function About() {
  return (
    <section
      id="our-story"
      data-testid="our-story-section"
      className="relative z-10 border-t border-white/5 py-24 md:py-36 bg-black/30 overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_50%_40%_at_85%_20%,rgba(130,73,55,0.25),transparent_65%)]" aria-hidden />
      <div className="relative max-w-[1100px] mx-auto px-6 md:px-12">
        <p className="overline">Our Story</p>
        <h2 className="font-serif-display text-[32px] sm:text-5xl lg:text-6xl mt-5 leading-[1.02] tracking-tight">
          Everybody has something <span className="italic text-[#D4AF37]">worth framing.</span>
        </h2>

        <p className="mt-10 font-serif-display text-xl md:text-2xl text-[#F7F1E7]/80 leading-relaxed">
          A journey. A relationship. A business. A graduation. A family.
          A comeback. A loved one. A dream that finally became real.
        </p>

        <div className="mt-8 space-y-5 text-white/65 font-light leading-relaxed text-base md:text-lg max-w-3xl">
          <p>
            Crowned Canvas Creations was built around a simple belief: those
            stories deserve more than an ordinary photograph.
          </p>
          <p>
            We transform meaningful moments into personalized works of art
            designed around the people and stories behind them.
          </p>
        </div>

        <div className="mt-14 border-l-2 border-[#D4AF37] pl-6 md:pl-10">
          <p className="font-serif-display text-2xl md:text-4xl leading-[1.15] text-[#F7F1E7]">
            Sometimes you&apos;re not decorating a wall. You&apos;re displaying{" "}
            <span className="italic text-[#D4AF37]">proof of how far you&apos;ve come.</span>
          </p>
          <p className="overline mt-6">Crowned Canvas Creations</p>
          <p className="text-white/50 text-sm mt-1 font-light">Where your story becomes a masterpiece.</p>
        </div>
      </div>
    </section>
  );
}
